import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

export interface LinkedDevice {
  id: number;
  device_id: string;
  location_id: number;
  owner_id: number;
  name: string;
  floor: number;
}

export interface UnlinkedDevice {
  id: string;
  name: string;
  location: string;
  status: string;
  last_seen: string;
}

export interface DeviceCreate {
  device_id: string;
  location_id: number;
  owner_id: number;
  name: string;
  floor: number;
}

export interface DeviceUpdate {
  location_id: number;
  name: string;
  floor: number;
}

export function DevicesAPI(baseUrl: string) {
  return {
    list: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/devices?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<LinkedDevice[]>;
    },
    get: async (id: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/devices/${id}?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<LinkedDevice>;
    },
    create: async (deviceData: DeviceCreate) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.post(
        `${baseUrl}/devices?business_profile_id=${businessProfileId}`,
        deviceData,
        true,
      )) as ApiResponse<LinkedDevice>;
    },
    update: async (id: number, deviceData: DeviceUpdate) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.put(
        `${baseUrl}/devices/${id}?business_profile_id=${businessProfileId}`,
        deviceData,
        true,
      )) as ApiResponse<LinkedDevice>;
    },
    delete: async (id: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.delete(
        `${baseUrl}/devices/${id}?business_profile_id=${businessProfileId}`,
        true,
      )) as ApiResponse<{}>;
    },
    getUnlinked: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/devices/unlinked?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<UnlinkedDevice[]>;
    },
  };
}

